module.exports = __webpack_public_path__ + "img/crop.94d604c8.svg";